import type { CreateUserPayload } from '../models';
import type { CreateUserPayloadDto } from '../dto';

export function mapCreateUserPayloadToDto(payload: CreateUserPayload): CreateUserPayloadDto {
  return {
    first_name: payload.firstName,
    last_name: payload.lastName,
    email: payload.email,
    role_id: payload.roleId,
    firm_id: payload.firmId,
  };
}
